exports.year = 2021

exports.colors = {
  // representedRamp: ['#4d9221', '#708e3e', '#8c8856', '#a5816c', '#bc7882', '#d36c97', '#e85bad'],
  representedRamp: ['#479260', '#629772', '#7a9c84', '#91a097', '#a7a4a9', '#bca7bc', '#d1aacf'],
  userAge: '#4F4A3A',
  highlight: '#A3C8AF',
  user: '#9C1249',
  arrow: "#D5D3D3"
}

exports.bar = {
  size: 6
}

exports.size = {
  width: 668,
  height: 250,
}

exports.margin = {
  left: 50,
  right: 20,
  top: 60,
  bottom: 20,
}

exports.kings = {
  top: 10,
  r: 8,
  circleColor: this.colors.representedRamp[0],
  circleColorHover: exports.colors.highlight,//'#2CA29F',
  lineColor: this.colors.representedRamp[0],
  representingMargin: 10
}

exports.ageGroups = {
  '<18': 'unter 18-Jährige',
  '18-39': '18- bis 39-Jährige',
  '40-64': '40- bis 64-Jährige',
  '65-79': '65- bis 79-Jährige',
  '>80': 'über 80-Jährige'
}

exports.partyCleaned = {
  'parteilos': 'Parteilos',
  'fdp': "FDP",
  'evp': 'EVP',
  'svp': 'SVP',
  'sp': "SP",
  'cvp': "Die Mitte",
  'glp': 'GLP',
  'grüne': 'Grüne',
  'bdp': 'BDP',
  'al': 'AL',
  'edu': 'EDU',
  'verschiedene': 'andere',
  'vacant': 'vakant'
}

exports.partyInText = {
  'parteilos': 'Parteilosen',
  'fdp': "FDP",
  'evp': 'EVP',
  'svp': 'SVP',
  'sp': "SP",
  'cvp': "«Die Mitte»",
  'glp': 'GLP',
  'grüne': 'Grünen',
  'bdp': 'BDP',
  'al': 'AL',
  'edu': 'EDU',
  'verschiedene': 'andere',
  'vacant': 'vakant'
}

exports.partyColor = {
  parteilos: "#808080",
  cvp: "#D6862B",
  fdp: "#3872B5",
  evp: "#DEAA28",
  svp: "#4B8A3E",
  sp: "#F0554D",
  glp: "#C4C43D",
  grüne: "#84B547",
  bdp: "#E6C820",
  al: "#A83232",
  edu: "#A65E42",
  verschiedene: "#000",
  vacant: "#000",
}

exports.executive = {
  gemeinderat:
  {
    noun: 'Gemeinderat',
    m: 'Gemeinderat',
    w: 'Gemeinderätin',
  },
  stadtrat:
  {
    noun: 'Stadtrat',
    m: 'Stadtrat',
    w: 'Stadträtin',
  }
}